import React, { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Container, Table, Form, Button, Row, Col, Badge, Input } from "reactstrap";
import moment from 'moment'

import { ToastContainer } from "react-toastify";
import { Redirect } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getAllMachines } from "../../store/actions/machineActions";


class ViewAllMachines extends Component {
  state = {
    UHANo: "",
    filterBy: null,
    filteredData: null,
    unit: '',
    state: '',
    location: '',
    name: '',
    resultText: '',
    disabledFilters: true
  };

  handleFilter = (e) => {
    if (this.props.machines && this.props.machines.length) {
      let filteredData;
      if (this.state.filteredData == null) {
        filteredData = this.props.machines.filter(function (el) {
          return el[e.target.name] == e.target.value;
        });
        this.setState({
          filterBy: e.target.name,
          filteredData,
          resultText: e.target.name + ' - ' + e.target.value
        });
        e.target.disabled = true;
      } else {
        filteredData = this.state.filteredData.filter(function (el) {
          return el[e.target.name] == e.target.value;
        });
        this.setState({
          filterBy: e.target.name,
          filteredData,
          resultText: this.state.resultText + ', ' + e.target.name + ' - ' + e.target.value
        });
        e.target.disabled = true;
      }
    }
  };

  setLocation = (e) => {
    this.setState({
      location: e.target.value
    });
  }

  setName = (e) => {
    this.setState({
      name: e.target.value
    });
  }

  resetFilter = () => {
    this.setState({
      filterBy: null,
      filteredData: this.props.machines,
      disabledFilters: false,
      resultText: ''
    });
    if (document.getElementById("unit")) {
      document.getElementById("unit").disabled = false;
    }

    document.getElementById("status").disabled = false;
    document.getElementById("locationInput").disabled = false;
    document.getElementById("location").disabled = false;
    document.getElementById("nameInput").disabled = false;
    document.getElementById("name").disabled = false;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.getAllMachines(
      this.props.profile.unit,
      this.props.profile.userType
    );
    this.setState({
      disabledFilters: false,
    });
  };


  compareValues = (key, order = 'asc') => {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  render() {

    return (
      <div>
        {this.props.auth && this.props.auth.isEmpty === false ? (
          <Container fluid>
            <Row className="mt-3">
              <Col lg="12">
        <span className="float-right lead result-block">Result Count <b>{this.state.resultText.toUpperCase()}</b> 
                    {this.state.filteredData != null ?
                        (<span className="h3 result-block result-count"> {this.state.filteredData.length}</span>) :
                        (this.props.machines ? (<span className="h3 result-block result-count"> {this.props.machines.length}</span>) : (<span className="h3 result-block result-count"> 0 </span>))}

                </span>
            
              </Col>
            </Row>
            <Row className="mt-2 mb-3">
              <Col lg="2" className="mt-3">
                <Form onSubmit={this.handleSubmit}>
                  <Button color="primary" block>View Machines</Button>
                </Form>
              </Col>
              {/* <Col md="3">
                <Button onClick={this.handleFilter}>Filter By Status</Button>
              </Col> */}

              <Col lg="10">
                <Form>
                  <Row>
                    {this.props.profile.userType == 'admin' || this.props.profile.userType == 'viewer' ? (

                      <Col lg="2" className="mt-3">
                        <Input disabled={this.state.disabledFilters} type="select" name="unit" id="unit" onChange={this.handleFilter}>
                          <option value="No Value">Select Unit</option>
                          <option value="1 SLE">1 SLE</option>
                          <option value="2 SLE">2 SLE</option>
                          <option value="3 SLE">3 SLE</option>
                          <option value="4 SLE">4 SLE</option>
                          <option value="5 SLE">5 SLE</option>
                          <option value="6 SLE">6 SLE</option>
                          <option value="7 SLE">7 SLE</option>
                          <option value="8 SLE">8 SLE</option>
                          <option value="9 SLE">9 SLE</option>
                          <option value="10 SLE">10 SLE</option>
                          <option value="11 SLE">11 SLE</option>
                          <option value="12 SLE">12 SLE</option>
                          <option value="SLSME">SLSME</option>
                          <option value="WKSP">WKSP</option>
                        </Input>
                      </Col>
                    ) : null}
                    <Col lg="2" className="mt-3">
                      <Input disabled={this.state.disabledFilters} type="select" name="status" id="status" onChange={this.handleFilter}>
                        <option value={this.state.status}>Select Status</option>
                        <option value="On">On</option>
                        <option value="Off">Off</option>
                      </Input>
                    </Col>

                    <Col lg="3" className="d-flex mt-3">
                      <Input disabled={this.state.disabledFilters} placeholder="Location" type="text" name="locationInput" id="locationInput" onChange={this.setLocation} >
                      </Input>
                      <Button color="primary" size="md" disabled={this.state.disabledFilters} name="location" id="location" className="ml-2" onClick={this.handleFilter} value={this.state.location}>search</Button>
                    </Col>

                    <Col lg="3" className="d-flex mt-3">
                      <Input disabled={this.state.disabledFilters} placeholder="Name" type="text" name="nameInput" id="nameInput" onChange={this.setName} >
                      </Input>
                      <Button color="primary" size="md" disabled={this.state.disabledFilters} name="name" id="name" className="ml-2" onClick={this.handleFilter} value={this.state.name}>search</Button>
                    </Col>

                    <Col lg="2" className="mt-3">
                      <Button disabled={this.state.disabledFilters} type="reset" onClick={this.resetFilter} color="warning"  block>Reset Filter</Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        ) : null}

        {this.props.auth && this.props.auth.isEmpty === false ? (
          this.props.machines ? (
            <Container fluid>
              {this.state.filterBy == null ? (
                <Table striped responsive>
                  <thead>
                    <tr>
                      <th>UHA No</th>
                      <th>Type Identity</th>
                      <th>Model</th>
                      <th>Machine Name</th>
                      <th>Unit</th>
                      <th>Location</th>
                      <th>Task</th>
                      <th>Date Off RD</th>
                      <th>Remarks</th>
                      <th>Last Update</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.props.machines.sort(this.compareValues('createdAt', 'desc')).map((machine) => {
                      return (
                        <tr key={machine.id}>
                          <td>{machine.UHANo}</td>
                          <td>{machine.typeIdentity}</td>
                          <td>{machine.model}</td>
                          <td>{machine.name}</td>
                          <td>{machine.unit}</td>

                          <td>
                            {machine.location && machine.location.length
                              ? machine.location
                              : "-"}
                          </td>
                          <td>
                            {machine.task && machine.task.length
                              ? machine.task
                              : "-"}
                          </td>
                          <td>
                            {machine.dateOffRd && machine.dateOffRd.length
                              ? machine.dateOffRd
                              : "-"}
                          </td>
                          <td>
                            {machine.remarks && machine.remarks.length
                              ? machine.remarks
                              : "-"}
                          </td>

                          <td>
                            {machine.createdAt
                              ? moment(machine.createdAt.toDate()).calendar()
                              : "-"}
                          </td>
                          <td>
                            {machine.status && machine.status.length ? (
                              machine.status === "On" ? (
                                <Badge className="badge-success">
                                  {machine.status}
                                </Badge>
                              ) : (
                                  <Badge className="badge-danger">
                                    {machine.status}
                                  </Badge>
                                )
                            ) : (
                                "-"
                              )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) :
                <Table striped responsive>
                  <thead>
                    <tr>
                      <th>UHA No</th>
                      <th>Type Identity</th>
                      <th>Model</th>
                      <th>Machine Name</th>
                      <th>Unit</th>
                      <th>Location</th>
                      <th>Task</th>
                      <th>Date Off RD</th>
                      <th>Remarks</th>
                      <th>Last Update</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {this.state.filteredData.map((machine) => {
                      return (
                        <tr key={machine.id}>
                          <td>{machine.UHANo}</td>
                          <td>{machine.typeIdentity}</td>
                          <td>{machine.model}</td>
                          <td>{machine.name}</td>
                          <td>{machine.unit}</td>

                          <td>
                            {machine.location && machine.location.length
                              ? machine.location
                              : "-"}
                          </td>
                          <td>
                            {machine.task && machine.task.length
                              ? machine.task
                              : "-"}
                          </td>
                          <td>
                            {machine.dateOffRd && machine.dateOffRd.length
                              ? machine.dateOffRd
                              : "-"}
                          </td>
                          <td>
                            {machine.remarks && machine.remarks.length
                              ? machine.remarks
                              : "-"}
                          </td>

                          <td>
                            {machine.createdAt
                              ? moment(machine.createdAt.toDate()).calendar()
                              : "-"}
                          </td>
                          <td>
                            {machine.status && machine.status.length ? (
                              machine.status === "On" ? (
                                <Badge className="badge-success">
                                  {machine.status}
                                </Badge>
                              ) : (
                                  <Badge className="badge-danger">
                                    {machine.status}
                                  </Badge>
                                )
                            ) : (
                                "-"
                              )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              }
            </Container>
          ) : null
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    machines: state.machine.allMachines,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllMachines: (unit, userType) =>
      dispatch(getAllMachines(unit, userType)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ViewAllMachines
);
